import axios from 'axios';
export function getData(config) {
  return axios.get(config.url,
    {
      headers:buildHeaders(config),
      params: config.params
    }
  );
}

export function getHeadData(config) {
  return axios.head(config.url,
    {
      headers:buildHeaders(config)
    });
}

export function putData(config) {
  config.ContentType = config.contentType ? config.contentType : 'application/json';
  return axios.put(config.url, config.params,
    {
      headers:buildHeaders(config)
    }
  );
}

export function patchData(config) {
  config.ContentType = config.contentType ? config.contentType : 'application/json';
  return axios.patch(config.url, config.params,
    {
      headers:buildHeaders(config)
    }
  );
}

export function postData(config) {
  config.ContentType = config.contentType ? config.contentType : 'application/json';
  return axios.post(config.url, config.params,
    {
      headers:buildHeaders(config)
    });
}

function buildHeaders(config)
{
  let headers = {};
  if (config.ContentType)
  {
    headers['Content-Type'] = config.ContentType;
  }
  if (config.token)
  {
    headers.Authorization =  'Bearer ' + config.token;
  }
  return headers;
}
